module.exports = __webpack_public_path__ + "img/1 rice-intake.cbf1105f.jpeg";